<template>
  <div>
    <a-row class="field">
      <a-col
        style="text-align: left"
        :span="label_right ? 8 : 12"
        :style="
          size === 'large'
            ? { fontSize: 30 + 'px', width: '50%', fontWeight: 500 }
            : size === 'middle'
            ? { fontSize: 18 + 'px', width: '50%', fontWeight: 600 }
            : { fontSize: 14 + 'px', width: '50%', fontWeight: 600 }
        "
        class="label"
      >
        <span :style="label_left ? { marginLeft: 10 + 'px', fontWeight: 600 } : ''">
          {{ label_left }}
        </span>
        <span :style="label_left ? { marginLeft: 14 + 'px', fontWeight: 600 } : ''">
          <span v-if="item_left_1?.type === 'money'">
            ￥{{ numeral(item_left_1.v).format('0,0') }}
          </span>
          <span v-if="item_left_1?.type === 'person'">{{ item_left_1.v }}人</span>
          <span v-if="item_left_1?.type === 'percent'">{{ item_left_1.v }}}}%</span>
          <span>/</span>
          <span v-if="item_left_2?.type === 'money'">
            ￥{{ numeral(item_left_2.v).format('0,0') }}
          </span>
          <span v-if="item_left_2?.type === 'person'">{{ item_left_2.v }}人</span>
          <span v-if="item_left_2?.type === 'percent'">{{ item_left_2.v }}%</span>
        </span>

        <span style="font-size: 14px">
          <arrow-up-outlined style="color: crimson" v-if="icon === 'create' && is_up === true" />
          <arrow-down-outlined
            style="color: limegreen"
            v-else-if="icon === 'create' && is_up === false"
          />
          <caret-up-outlined
            style="color: crimson; margin-left: 10px"
            v-if="icon === 'arrow' && is_up === true"
          />
          <caret-down-outlined
            style="color: limegreen"
            v-else-if="icon === 'arrow' && is_up === false"
          />
        </span>
      </a-col>

      <a-col
        :span="label_right ? 10 : 12"
        :style="
          label_right
            ? { textAlign: 'center', lineHeight: 17 + 'px' }
            : { textAlign: 'right', lineHeight: 32 + 'px' }
        "
      >
        <span
          :style="
            size === 'large'
              ? { fontSize: 22 + 'px', color: '#999999', fontWeight: 500 }
              : { fontSize: 14 + 'px', color: '#999999', fontWeight: 500 }
          "
        >
          <span v-if="item_center_1?.type === 'money'">
            ￥{{ numeral(item_center_1.v).format('0,0') }}
          </span>
          <span v-if="item_center_1?.type === 'person'">{{ item_center_1.v }}人</span>
          <span v-if="item_center_1?.type === 'percent'">{{ item_center_1.v }}%</span>
          <span>/</span>
          <span v-if="item_center_2?.type === 'money'">
            ￥{{ numeral(item_center_2.v).format('0,0') }}
          </span>
          <span v-if="item_center_2?.type === 'person'">{{ item_center_2.v }}人</span>
          <span v-if="item_center_2?.type === 'percent'">{{ item_center_2.v }}%</span>
        </span>
      </a-col>
      <a-col :span="label_right ? 6 : 0" style="text-align: right">
        <span style="font-size: 10px; margin-left: 8px;, fontWeight: 500">
          <span>{{ label_right }}</span>
          <span v-if="item_right?.type === 'money'">
            ￥{{ numeral(item_right.v).format('0,0') }}
          </span>
          <span v-if="item_right?.type === 'person'">{{ item_right.v }}人</span>
          <span v-if="item_right?.type === 'percent'">{{ item_right.v }}%</span>
        </span>
      </a-col>
    </a-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {
  ArrowUpOutlined,
  ArrowDownOutlined,
  CaretUpOutlined,
  CaretDownOutlined,
} from '@ant-design/icons-vue';
import numeral from 'numeral';

export default defineComponent({
  name: 'PaneItem',
  props: {
    label_left: {
      type: String,
      default: () => undefined,
    },
    size: {
      type: String,
      default: () => undefined,
    },
    item_left_1: {
      type: Object,
      default: () => undefined,
    },
    item_left_2: {
      type: Object,
      default: () => undefined,
    },
    is_up: {
      type: Boolean,
      default: () => undefined,
    },
    icon: {
      type: String,
      default: () => 'create_up',
    },
    item_center_1: {
      type: Object,
      default: () => undefined,
    },
    item_center_2: {
      type: Object,
      default: () => undefined,
    },
    label_right: {
      type: String,
      default: () => undefined,
    },
    item_right: {
      type: [Boolean, Object],
      default: () => undefined,
    },
  },
  setup() {
    return {
      numeral,
    };
  },
  components: {
    CaretUpOutlined,
    CaretDownOutlined,
    ArrowUpOutlined,
    ArrowDownOutlined,
  },
});
</script>

<style lang="less" scoped>
@import './index.less';
</style>
